var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MemorizeItemInstruction"},[_c('div',{staticClass:"instruction",style:({ color: _vm.theme.primaryColor })},[_vm._v("\n        "+_vm._s(_vm.$t('instruction'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }